import useStableObjectReference from 'hooks/useStableObjectReference'
import noop from 'lib/function/noop'
import React, { PropsWithChildren, useCallback } from 'react'

export enum OfferListEvents {
  productClick,
  impression,
  listLoad,
  clientAction,
}

export interface OfferImpressionData {
  offer: App.Offer
  index: number
}

export interface OfferClickData {
  offer: App.Offer
  index: number
}

export interface OfferListLoadData {
  key: string,
  list: {
    error: string,
    fetching: boolean,
    offerIds: Array<string>
  },
}

type OfferListAction = (action: OfferListEvents, data?: any, additionalData?: any) => void
const OfferListEventsContext = React.createContext<OfferListAction>(noop)

interface Props {
  onListEvent: OfferListAction;
  /**
   * Use this to augment any data to the `onListEvent` function
   */
  additionalData?: any;
}

export function OfferListEventsProvider(props: PropsWithChildren<Props>) {
  const { onListEvent, additionalData } = props
  const stableAdditionalData = useStableObjectReference(additionalData)
  const value = useCallback((action, data) => {
    onListEvent(action, data, stableAdditionalData)
  }, [onListEvent, stableAdditionalData])

  return <OfferListEventsContext.Provider value={value}>
    {props.children}
  </OfferListEventsContext.Provider>
}

export default OfferListEventsContext
